(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["tc-announcement"] && !Shopify.designMode) return;
  try {
    
  (function () {
  function boot() {
  if (!window.TC || !TC.init) return;
  TC.init('[data-tc-announcement]', function (bar) {
    var key = bar.getAttribute('data-tc-key');
    var closed = false;
    try { closed = sessionStorage.getItem(key) === '1'; } catch (e) {}
    if (closed && !(window.TC_CONFIG && window.TC_CONFIG.designMode)) bar.classList.add('hidden');
    var btn = bar.querySelector('[data-tc-announcement-close]');
    if (btn) btn.addEventListener('click', function () {
      bar.classList.add('hidden');
      try { sessionStorage.setItem(key, '1'); } catch (e) {}
      document.dispatchEvent(new CustomEvent('tc:header:resize'));
    });
  });
  }
  if (window.TC && TC.init) boot(); else document.addEventListener('DOMContentLoaded', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tc-blue-box"] && !Shopify.designMode) return;
  try {
    
  (function () { function boot() { TC.init('[data-tc-blue-box]', initBlueBox); } if (window.TC && TC.init) boot(); else document.addEventListener('DOMContentLoaded', boot); })();
  function initBlueBox(root) {
    /* the captured CSS fixes every row at --collapsed-height; the source script sets the open row's height inline (header + body) */
    function setHeights() { Array.prototype.forEach.call(root.querySelectorAll('[data-tc-row]'), function (r) { var on = r.classList.contains('active'); var head = r.querySelector('.collapsible-header'); var body = r.querySelector('.collapsible-body'); if (!on || !head || !body) { r.style.height = ''; return; } var h = head.getBoundingClientRect().height + body.getBoundingClientRect().height; if (h > 0) r.style.height = Math.round(h) + 'px'; }); }
    if ('ResizeObserver' in window) { var ro = new ResizeObserver(function () { window.requestAnimationFrame(setHeights); }); Array.prototype.forEach.call(root.querySelectorAll('.collapsible-body'), function (b) { ro.observe(b); }); }
    Array.prototype.forEach.call(root.querySelectorAll('.collapsible-body img'), function (img) { img.addEventListener('load', setHeights); });
    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-tc-row-toggle]'); if (!btn) return;
      var row = btn.closest('[data-tc-row]'); var open = !row.classList.contains('active');
      Array.prototype.forEach.call(root.querySelectorAll('[data-tc-row]'), function (r) { var on = open && r === row; r.classList.toggle('active', on); var t = r.querySelector('[data-tc-row-toggle]'); if (t) t.setAttribute('aria-expanded', on ? 'true' : 'false'); });
      setHeights();
    });
    setHeights(); window.addEventListener('load', setHeights); setTimeout(setHeights, 1200);
    var rt = null; window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(setHeights, 150); });
    document.addEventListener('shopify:block:select', function (e) { var row = e.target.closest('[data-tc-row]'); if (row && root.contains(row)) { var t = row.querySelector('[data-tc-row-toggle]'); if (t && !row.classList.contains('active')) t.click(); } });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tc-cart"] && !Shopify.designMode) return;
  try {
    
  (function () { function boot() { TC.init('.tc-cart', initCartPanels); } if (window.TC && TC.init) boot(); else document.addEventListener('DOMContentLoaded', boot); })();
  function initCartPanels(root) {
    root.addEventListener('click', function (e) {
      var tip = e.target.closest('[data-tc-tooltip]');
      if (tip) { e.preventDefault(); var body = root.querySelector('#' + tip.getAttribute('aria-controls')); if (body) { var open = body.hidden; body.hidden = !open; tip.setAttribute('aria-expanded', open ? 'true' : 'false'); } return; }
      var col = e.target.closest('[data-tc-collapse]');
      if (col) { e.preventDefault(); var panel = root.querySelector('#' + col.getAttribute('aria-controls')); if (!panel) return; var show = !panel.classList.contains('show'); panel.classList.toggle('show', show); col.classList.toggle('collapsed', !show); col.setAttribute('aria-expanded', show ? 'true' : 'false'); }
    });
    document.addEventListener('click', function (e) { if (!e.target.closest('.tooltip-main')) Array.prototype.forEach.call(root.querySelectorAll('.tc-tooltip'), function (t) { t.hidden = true; }); });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tc-film-band"] && !Shopify.designMode) return;
  try {
    
  (function () { function boot() { TC.init('[data-tc-film]', initFilm); } if (window.TC && TC.init) boot(); else document.addEventListener('DOMContentLoaded', boot); })();
  function initFilm(root) {
    var video = root.querySelector('video'); if (!video) return;
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var pp = root.querySelector('[data-tc-playpause]'); var mu = root.querySelector('[data-tc-mute]');
    function paint() { var paused = video.paused; root.classList.toggle('is-paused', paused); if (pp) pp.classList.toggle('playing', !paused); if (mu) { mu.classList.toggle('muted', video.muted); Array.prototype.forEach.call(mu.querySelectorAll('button'), function (b) { b.setAttribute('aria-pressed', b.classList.contains('mutebtn') ? String(video.muted) : String(!video.muted)); }); } }
    video.muted = true;
    if (reduced || root.dataset.tcAutoplay !== 'true') { video.removeAttribute('autoplay'); video.pause(); } else { var p = video.play(); if (p && p.catch) p.catch(function () {}); }
    ['play', 'pause', 'volumechange'].forEach(function (ev) { video.addEventListener(ev, paint); });
    root.addEventListener('click', function (e) {
      if (e.target.closest('.playbtn, .pausebtn')) { e.preventDefault(); if (video.paused) { var q = video.play(); if (q && q.catch) q.catch(function () {}); } else video.pause(); return; }
      if (e.target.closest('.mutebtn, .unmutebtn')) { e.preventDefault(); video.muted = !video.muted; paint(); }
    });
    paint();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tc-footer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function boot() {
      if (!window.TC || !TC.init) return;
      TC.init('[data-tc-footer]', function (root) {
        root.querySelectorAll('[data-tc-collapsible-toggle]').forEach(function (btn) {
          btn.addEventListener('click', function () {
            var item = btn.closest('[data-tc-collapsible]'); if (!item) return;
            var open = item.classList.toggle('active');
            btn.setAttribute('aria-expanded', open ? 'true' : 'false');
          });
        });
        root.addEventListener('shopify:block:select', function (e) { var item = e.target.closest('[data-tc-collapsible]'); if (item) { item.classList.add('active'); var b = item.querySelector('[data-tc-collapsible-toggle]'); if (b) b.setAttribute('aria-expanded', 'true'); } });
      });
    }
    if (window.TC && TC.init) boot(); else document.addEventListener('DOMContentLoaded', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tc-welcome-modal"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function boot() {
      if (!window.TC || !TC.init) return;
      TC.init('[data-tc-welcome]', function (modal) {
        var key = modal.getAttribute('data-key');
        var show = modal.getAttribute('data-show');
        var design = !!(window.TC_CONFIG && window.TC_CONFIG.designMode);
        var seen = false;
        try { seen = sessionStorage.getItem(key) === '1'; } catch (e) {}
        modal.addEventListener('tc:overlay:close', function () { if (!design) { try { sessionStorage.setItem(key, '1'); } catch (e) {} } });
        if (show === 'session' && !seen && !design) setTimeout(function () { if (document.body.contains(modal)) TC.overlay.open(modal); }, 400);
      });
    }
    if (window.TC && TC.init) boot(); else document.addEventListener('DOMContentLoaded', boot);
  })();

  } catch(e) { console.error(e); }
})();
})();
